import { render, staticRenderFns } from "./user-add-or-update.vue?vue&type=template&id=65383c1e&"
import script from "./user-add-or-update.vue?vue&type=script&lang=js&"
export * from "./user-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./user-add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports